<body>
  <div class="main">
    <div class="grid-overlay">
      <div class="nav">
        <a href="/">{{ 'login.nav.back' | translate }}</a>
      </div>
      <div class="logoblock"><img (click)="goHome()" src="../../assets/images/BRAND.png" alt="Logo Billcentrix">
        <h2>{{ 'resetPassword.title' | translate }}</h2>
      </div>


      <div class="background-white">
        <h1>{{ 'resetPassword.title' | translate }}</h1>
        <form class="user" [formGroup]="resetForm" (ngSubmit)="reset()" >
          <input [formControl]="resetForm.controls['email']"  type="email" class="form-control form-control-user" id="exampleInputEmail" aria-describedby="emailHelp" [placeholder]="'resetPassword.form.emailPlaceholder' | translate">
          @if (resetForm.controls['email'].hasError('required') && resetForm.controls['email'].touched) {
            <small
            class="form-error-msg">{{ 'createAccount.form.emailRequired' | translate }}</small>
          }
          @if (resetForm.controls['email'].hasError('email') && resetForm.controls['email'].touched) {
            <small
            class="form-error-msg">{{ 'createAccount.form.emailInvalid' | translate }}</small>
          }
          <div class="options">
            <button class="crear" type="btn" [disabled]="resetForm.invalid" >{{ 'resetPassword.form.submit' | translate }}</button>
          </div>
        </form>
        <div class="logear">{{ 'resetPassword.existingAccount.question' | translate }}<button (click)="onLoginClick()" >{{ 'resetPassword.existingAccount.login' | translate }}</button></div>

      </div>
    </div>

  </div>
  <app-footer></app-footer>





